var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M4.69531 0.671875H21.6953C23.6283 0.671875 25.1953 2.23888 25.1953 4.17188V9.17188C25.1953 11.1049 23.6283 12.6719 21.6953 12.6719H4.69531C2.76232 12.6719 1.19531 11.1049 1.19531 9.17188V4.17188C1.19531 2.23888 2.76232 0.671875 4.69531 0.671875Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6953 5.17188V9.39222C27.5444 9.03478 28.0965 8.20328 28.0965 7.28205C28.0965 6.36082 27.5444 5.52931 26.6953 5.17188Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69531 4.17188C2.69531 3.06731 3.59074 2.17188 4.69531 2.17188H21.6953C22.7999 2.17188 23.6953 3.06731 23.6953 4.17188V9.17188C23.6953 10.2764 22.7999 11.1719 21.6953 11.1719H4.69531C3.59074 11.1719 2.69531 10.2764 2.69531 9.17188V4.17188Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.a219d7edb302b527021e77e426ba1c5c.svg";
export { ForwardRef as ReactComponent };